import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import EditableTextArea from 'components/forms/editableTextArea';

class NewPlasterText extends React.Component {
  static defaultProps = {
    plasterText: '',
  };

  static propTypes = {
    dataChanged: PropTypes.func.isRequired,
    plasterText: PropTypes.string,
    toggleNewPlaster: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired,
    saveNewPlaster: PropTypes.func,
  };

  shouldComponentUpdate(props) {
    if (props.plasterText === this.props.plasterText && props.visible === this.props.visible) {
      return false;
    }
    return true;
  }

  render() {
    let plasterText = this.props.plasterText;
    const maxNewPlasterLength = 200;

    if (this.props.visible) {
      return <div className='container new-plaster-modal' style={{position: 'fixed', bottom: '50px'}}>
        <div className='row'>
          <div className='col-xs-6'>{plasterText ? plasterText.length : 0}/{maxNewPlasterLength} <FormattedMessage id="footer.characters.used" /></div>
          <div className='col-xs-6'>
            <button className='btn' onClick={this.props.saveNewPlaster} disabled={plasterText && plasterText.length > maxNewPlasterLength}>
              <i className='bl bl-check' />
            </button>
            <button className='btn' onClick={this.props.toggleNewPlaster} ><i className='bl bl-cancel' /></button>
          </div>
        </div>

        <div className='row'>
          <div className='col-xs-12'>
            <EditableTextArea
              editMode={true}
              dataKey='newPlasterText'
              onChange={this.props.dataChanged}
              value={plasterText}
              placeholder={this.props.intl.formatMessage({id: 'footer.new.plaster.startup'})} />
          </div>
        </div>
      </div>;
    }
    return <div />;
  }
}

export default injectIntl(NewPlasterText);
